import CommitteesPage from "./pages/CommitteesPage";
import CommitteeDetailsPage from "./pages/CommitteeDetailsPage";

/** Gated on the privilege — see the note in chapter/routes.tsx. */
export const committeesRoutes = [
  { path: "/committees", element: <CommitteesPage />, perms: ["committee.access"] },
  {
    path: "/committees/:id",
    element: <CommitteeDetailsPage />,
    perms: ["committee.access"],
  },
];
